import { Link, useLocation } from 'react-router-dom'

/**
 * หน้าเปล่าของเมนูที่ยังไม่ได้ทำ — มีไว้ให้เมนูกดได้ครบตั้งแต่ตอนนี้
 * ทำเป็นหน้าจริงแทนการซ่อนเมนู เพราะทีมจะได้เห็นโครงเมนูทั้งชุดตอนรีวิว
 */
export default function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <>
      <h1>{title}</h1>
      <section className="card">
        <p>{note}</p>
        <p className="meta">หน้านี้ยังไม่ได้ทำ — รอต่อ API ของส่วนนี้</p>
      </section>
    </>
  )
}

export function NotFound() {
  const { pathname } = useLocation()

  return (
    <>
      <h1>ไม่พบหน้านี้</h1>
      <section className="card">
        <p>
          ไม่มีหน้า <code>{pathname}</code> ในระบบ
        </p>
        <p>
          <Link to="/">กลับหน้าแรก</Link>
        </p>
      </section>
    </>
  )
}
